(function () {
  'use strict';

  /* @ngdoc object
   * @name performanceDetailReport
   * @description
   *
   */
  angular
    .module('performanceDetailReport', [
      'ui.router'
    ]);
}());
